var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("中止合同"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("保存"),
      cancelText: _vm.$t("关闭"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "stopAt",
      label: _vm.$t("中止时间")
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      "disabled-date": _vm.disabledDate,
      type: "datetime",
      format: _vm.getFormatDate() + " HH:mm:ss" + _vm.dateChronaxie(),
      placeholder: _vm.$t("请选择") + _vm.$t("中止时间")
    },
    model: {
      value: _vm.dataFrom.stopAt,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "stopAt", $$v);
      },
      expression: "dataFrom.stopAt"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "reason",
      label: _vm.$t("中止原因")
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("中止原因"),
      "auto-size": {
        minRows: 3,
        maxRows: 5
      },
      maxLength: 200
    },
    model: {
      value: _vm.dataFrom.reason,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "reason", $$v);
      },
      expression: "dataFrom.reason"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };